import {
  getEntityBadgeClasses,
  getEntityBadgeLabel,
  getStatusBadge,
  handleInteractiveKeyDown,
} from './cardUtils';

const MatchCard = ({
  match,
  isLive = false,
  onClick,
  onEdit,
  onView,
  onManage,
  showActions = true,
  compact = false,
  showEntityBadge = false,
}) => {
  const status = getStatusBadge(match?.status, isLive);
  const interactive = typeof onClick === 'function';

  return (
    <article
      className={`card common-entity-card ${interactive ? 'common-entity-card--interactive' : ''} ${compact ? 'common-entity-card--compact' : ''}`}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={() => onClick?.(match)}
      onKeyDown={(event) => handleInteractiveKeyDown(event, () => onClick?.(match))}
    >
      <div className="card-body common-entity-card__body">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <h3 className="h6 mb-0 common-entity-card__title">{match?.tournamentName || match?.title || 'Match'}</h3>
          <span className={`badge ${status.className}`}>{status.label}</span>
        </div>

        <p className="mb-0 fw-semibold">{match?.teamAName || match?.team1 || 'Team A'} vs {match?.teamBName || match?.team2 || 'Team B'}</p>
        {match?.scoreSummary ? <p className="common-entity-card__meta mb-0">{match.scoreSummary}</p> : null}
        {match?.startTime ? <p className="common-entity-card__meta mb-0">{new Date(match.startTime).toLocaleString()}</p> : null}

        {showEntityBadge ? (
          <div className="d-flex align-items-center gap-2">
            <span className={`badge ${getEntityBadgeClasses(match?.entityType)}`}>{getEntityBadgeLabel(match?.entityType)}</span>
            <span className="common-entity-card__meta">{match?.entityName || 'Unknown scope'}</span>
          </div>
        ) : null}

        {showActions ? (
          <div className="common-entity-card__actions">
            {onView ? <button type="button" className="btn btn-sm btn-outline-primary" onClick={(e) => { e.stopPropagation(); onView(match); }}>View</button> : null}
            {onManage ? <button type="button" className="btn btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); onManage(match); }}>Open</button> : null}
            {onEdit ? <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); onEdit(match); }}>Edit</button> : null}
          </div>
        ) : null}
      </div>
    </article>
  );
};

export default MatchCard;
